import { render, staticRenderFns } from "./contract_stock.vue?vue&type=template&id=8b4bf456"
import script from "./contract_stock.vue?vue&type=script&lang=js"
export * from "./contract_stock.vue?vue&type=script&lang=js"
import style0 from "./contract_stock.vue?vue&type=style&index=0&id=8b4bf456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports